import { z } from 'zod';
// POST /api/scans/skipped (KIR-4993): content-free report of a file the agent
// did not scan because its request would exceed the /api/scans body limit.
export const SCAN_SKIPPED_REASONS = ['too_large'];
// Not strict: unknown keys (a newer agent's field, a stray `content`) are stripped.
export const scanSkippedRequestSchema = z.object({
    clientVersion: z.string().max(64).optional(),
    reason: z.enum(SCAN_SKIPPED_REASONS),
    fileType: z.string().min(1).max(128),
    absolutePath: z.string().min(1).max(4096),
    sizeBytes: z.number().int().nonnegative(),
    limitBytes: z.number().int().positive(),
    // Set only when the agent read the file, i.e. after a 413.
    encodedBytes: z.number().int().nonnegative().optional(),
});
// recorded: logged as a warning (AI-instruction file). ignored: any other file.
export const scanSkippedResponseSchema = z.object({
    status: z.enum(['recorded', 'ignored']),
});
//# sourceMappingURL=scan-skipped.js.map